import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#34445b";
function OST({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M12.684 8.728l1.507-2.352a1.523 1.523 0 00.623-2.977 1.522 1.522 0 00-1.53 2.4l-1.87 2.918a5.97 5.97 0 00-3.201 10.56 5.974 5.974 0 008.404-.829 5.97 5.97 0 001.327-4.374 5.976 5.976 0 00-5.26-5.346m-.686 9.092a3.165 3.165 0 01-2.928-4.38 3.165 3.165 0 014.729-1.393c.529.366.934.884 1.161 1.487a1.831 1.831 0 00-2.893 2.243 1.83 1.83 0 002.887.005 3.16 3.16 0 01-2.956 2.038" /><path  d="M12.684 8.728l1.507-2.352a1.523 1.523 0 00.623-2.977 1.522 1.522 0 00-1.53 2.4l-1.87 2.918a5.97 5.97 0 00-3.201 10.56 5.974 5.974 0 008.404-.829 5.97 5.97 0 001.327-4.374 5.976 5.976 0 00-5.26-5.346m-.686 9.092a3.165 3.165 0 01-2.928-4.38 3.165 3.165 0 014.729-1.393c.529.366.934.884 1.161 1.487a1.831 1.831 0 00-2.893 2.243 1.83 1.83 0 002.887.005 3.16 3.16 0 01-2.956 2.038" /></Svg>;
}
OST.DefaultColor = DefaultColor;
export default OST;